module.exports = __webpack_public_path__ + "img/05-defaul.e77d0ae4.png";